export default "__VITE_ASSET__Cz3JnB2S__"